import { Component } from '@angular/core';
import { isTabView } from '../../utils';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceHelper } from '../../providers/services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent {
  public isTabView: boolean;
  public form: FormGroup;
  public newPassword: string = '';
  public confirmPassword: string = '';
  public token: any;
  public inputType: string = 'password';
  public showPassword: any = false;
  public passwordUpdated: boolean = false;
  public countdown = 3; 

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private authServiceHelper: AuthServiceHelper,
    private router: Router
  ) {
    this.isTabView = isTabView();
    this.form = this.fb.group(
      {
        newPassword: ['', [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,20}$/)
        ]
        ],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordsMatchValidator }
    );
    this.token = this.activatedRoute.snapshot.queryParams['token'];
  }

  /**
   * @function passwordsMatchValidator
   * this Method is used to check passwords match
   */
  public passwordsMatchValidator(form: AbstractControl) {
    const password = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    if (password !== confirmPassword) {
      return { passwordMismatch: true };
    }
    return null;
  }

  get newPasswordControl() {
    return this.form.get('newPassword');
  }

  get confirmPasswordControl() {
    return this.form.get('confirmPassword');
  }

  /**
   * @function resetPassword
   * this Method is used to call the reset password API
   */
  public resetPassword() {
    this.authServiceHelper.resetNewPassword(this.form.value.newPassword, this.token).then(() => {
      this.passwordUpdated = true;
      const interval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(interval);
        this.router.navigate(['login']);
      }
    }, 1000);
  });
  }

  /**
   * @function togglePasswordVisibility
   * this Method is used to toggle password visibility
   */
  public togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
    this.inputType = this.showPassword ? 'text' : 'password';
  }
}
